import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal } from 'shared/actions/modal.action';

import {} from 'shared/actions/auth.action';
import TeacherInfo from 'web/components/common/TeacherInfo';

@connect(
  state => ({ modal: state.shared.modal }),
  { initModal },
)
class TeacherInfoContainer extends Component {
  render() {
    // console.log('modal!!', this.props.modal);
    return (
      <Dim onClick={this.props.initModal}>
        <TeacherInfo
          initModal={this.props.initModal}
          teacherData={this.props.modal}
        ></TeacherInfo>
      </Dim>
    );
  }
}

export default TeacherInfoContainer;
